import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import Typography from '../../../Typography/Typography';

export interface MultiOptionsSelectorHeaderParams {
  title: LangEnum;
}

const MultiOptionsSelectorHeader = ({ title }: MultiOptionsSelectorHeaderParams) => {
  const { translate } = useTranslation();

  return (
    <Box
      sx={{
        p: '12px',
      }}
    >
      <Typography variant="h8-medium">{translate(title)}</Typography>
    </Box>
  );
};

export default MultiOptionsSelectorHeader;
